import { Props } from '../@types';
import { createContext, useContext, useEffect, useState } from 'react';
import { usePreconfiguredFetch } from './useProvidePreconfiguredFetch';
import { useAuth } from './useAuth';
import { CONDUCTORS } from '../@types/const';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

type ConductorContextType = {
    conductors: string[] | undefined;
    hasConductorError: boolean;
}

const ConductorContext = createContext<ConductorContextType>({
    conductors: undefined,
    hasConductorError: false
})

const useProvideConductors = () => {
    const { user } = useAuth();
    const { fetchResource } = usePreconfiguredFetch();
    const [conductors, setConductors] = useState<string[]>();
    const [hasConductorError, setHasConductorError] = useState(false);

    useEffect(() => {
        if (!user || !user.accessToken) {
            return
        }

        const storedConductors = localStorage.getItem(CONDUCTORS);
        if (!!storedConductors) {
            setConductors(storedConductors.split(','))
            return
        }

        const getConductors = async () => {
            try {
                const response = await fetchResource(`${API_ENDPOINT}/conductor/`)
                if (!response.ok) {
                    console.error("failed to fetch conductors; status:", response.status)
                    setHasConductorError(true)
                    return;
                }
                const data: string[] = await response.json()
                setConductors(data);
            } catch (error: any) {
                console.error("failed to fetch conductors; error:", error)
                setHasConductorError(true)
            }
        }
        getConductors();
    }, [user, conductors?.length])

    useEffect(() => {
        if (!!conductors && conductors.length > 0) {
            localStorage.setItem(CONDUCTORS, conductors.join(','));
        }
    }, [conductors])

    return {
        conductors,
        hasConductorError
    }
}

const useConductors = () => {
    return useContext(ConductorContext);
}

const ProvideConductors = ({ children }: Props) => {
    const conductorContext = useProvideConductors();

    return (<ConductorContext.Provider value={conductorContext}>
        {children}
    </ConductorContext.Provider>);
}

export { useConductors, ProvideConductors }